import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '../layout/index.vue'

const routes = [
  {
    path:'/excelToJson',
    component:()=>import('@/views/basic/ExcelToJson.vue')
  },
  {
    path:'/login',
    name:'login',
    component:()=>import('@/views/login/index.vue')
  },
  {
    path:'/register',
    name:'register',
    component:()=>import('@/views/login/register.vue')
  },
  {
    path: '/',
    name: 'Layout',
    redirect:'/index',
    component:Layout,
    children:[
     {
      path:'/index',
      name:'Index',
      component:()=>import('@/views/page/index.vue')
     }
    ]
  },
  {
      path: '/home',
      name: 'home-page',
      component:Layout ,
  }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title);

  if(['/login','/register'].includes(to.path)){
    next();
  }else{
    const token=localStorage.getItem('token')
    const username=localStorage.getItem('name')
    if(!token||!username){
      next('/login')
      return
    }else{
      next()
    }
    // else{
    //   http({
    //     url: "/checkToken",
    //     method: "post",
    //     data: {
    //         token,
    //         username
    //     },
    // })
    //     .then((res) => {
    //         if(!res.data.available){
    //             localStorage.clear()
    //             ElMessage.error('当前登录已过期，请重新登录')
    //             next('/login')
    //         }else{
    //           next()
    //         }
    //     })
    // }
  }
});
export default router
